import Cookies from 'js-cookie';
import md5 from 'md5';

function addExpires() {
  const d = new Date();
  const year = d.getFullYear();
  const month = d.getMonth();
  const day = d.getDate();
  return new Date(year + 20, month, day); // 20 years
}

export function generateBrowserID() {
  if (process.server) return '';
  const currentBrowserID = Cookies.get('browser_id');
  if (currentBrowserID) return currentBrowserID;
  const newBrowserID = md5(`${Math.random()}-${Date.now()}`);
  const expires = addExpires();
  Cookies.set('browser_id', newBrowserID, {
    expires,
    domain: window.location.hostname.replace(/^.+?\./, '.'),
    path: '/',
  });
  return newBrowserID;
}

export const getPlatform = () => {
  const platforms = [
    { value: 'mitralite_bl_android', name: 'Mitra BL App', regex: /(blandroid)/i },
    { value: 'mitralite_bl_ios', name: 'Mitra BL App', regex: /(blios)/i },
    { value: 'mitralite_bl_mitra_android', name: 'Mitra App', regex: /BLMitraAndroid/i },
    { value: 'mitra_b2b_android', name: 'Mitra B2B Android', regex: /MitraB2BAndroid/i },
    { value: 'mitralite_referencia', name: 'Mitra PWA', regex: /.*/i },
  ];
  return platforms.find(p => p.regex.test(window.navigator.userAgent));
};

export const getTrackerPlatform = () => {
  return getPlatform().value;
};
